import React from 'react'

const Logo = ({w,h}) => {
  return (
    <div>
    <strong>ElectroPlaza</strong>
  </div>
  )
}

export default Logo
